<template>
  <div>
    <b-row>
      <b-col>
        <payment-methods />
      </b-col>
    </b-row>
    <b-row>
      <b-col md="6">
        <subscription />
      </b-col>
      <b-col md="6">
        <reset-password />
      </b-col>
    </b-row>
  </div>
</template>
<script>
import PaymentMethods from './Settings/PaymentMethods'
import Subscription from './Settings/Subscription'
import ResetPassword from './Settings/ResetPassword'

export default {
  components: {
    PaymentMethods,
    Subscription,
    ResetPassword,
  }
}
</script>
<style>
</style>
